import { _t } from "app/i18n/i18n";

// gets regions for menu bar regions dropdown
export const getRegions = (assetClass, subCategory) => {
  let regions = allRegions;

  if (assetClass === "Equity") {
    if (subCategory === "Anchor Report") {
      regions = noGlobalAmericas;
    } else {
      regions = noGlobal;
    }
  }

  if (assetClass === "Economics") {
    if (subCategory === "Anchor Report") {
      regions = ["All Regions"];
    } else if (subCategory === "Special Report") {
      regions = noJapan;
    }
  }

  // returns [{value: "Japan", label: "日本" }, ...]
  regions = regions.map(addTranslations);

  return regions;
};

export const addTranslations = (value) => ({ label: _t(value), value });

const noGlobalAmericas = ["All Regions", "Japan", "Asia ex-Japan", "EMEA"];
const noGlobal = ["All Regions", "Japan", "Asia ex-Japan", "EMEA", "Americas"];
const noJapan = ["All Regions", "Global", "Asia ex-Japan", "EMEA", "Americas"];
const allRegions = ["All Regions", "Global", "Japan", "Asia ex-Japan", "EMEA", "Americas"];
